"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateIntegrationData = void 0;
var services_jobot_scheduler_1 = require("@playq/services-jobot-scheduler");
var services_adhawk_creds_1 = require("@playq/services-adhawk-creds");
var services_common_adhawk_1 = require("@playq/services-common-adhawk");
var CreateIntegrationData = (function () {
    function CreateIntegrationData(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            this.credentials = [];
            this.tasks = [];
            return;
        }
        this.provider = services_common_adhawk_1.CredsProvider[data.provider];
        this.name = data.name;
        this.credentials = data.credentials.map(function (e) { return new services_adhawk_creds_1.CredentialField(e); });
        this.tasks = data.tasks.map(function (e) { return new services_jobot_scheduler_1.RecurringTask(e); });
        this.meta = typeof data.meta !== 'undefined' ? Object.keys(data.meta).reduce(function (previous, current) { previous[current] = data.meta[current]; return previous; }, {}) : undefined;
    }
    CreateIntegrationData.prototype.getPackageName = function () { return CreateIntegrationData.PackageName; };
    CreateIntegrationData.prototype.getClassName = function () { return CreateIntegrationData.ClassName; };
    CreateIntegrationData.prototype.getFullClassName = function () { return CreateIntegrationData.FullClassName; };
    Object.defineProperty(CreateIntegrationData.prototype, "provider", {
        get: function () {
            return this._provider;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field provider is not optional');
            }
            this._provider = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateIntegrationData.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateIntegrationData.prototype, "credentials", {
        get: function () {
            return this._credentials;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field credentials is not optional');
            }
            this._credentials = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateIntegrationData.prototype, "tasks", {
        get: function () {
            return this._tasks;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field tasks is not optional');
            }
            this._tasks = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CreateIntegrationData.prototype, "meta", {
        get: function () {
            return this._meta;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._meta = undefined;
                return;
            }
            this._meta = value;
        },
        enumerable: false,
        configurable: true
    });
    CreateIntegrationData.prototype.toSchedulingBriefBaseSerialized = function () {
        return {
            provider: services_common_adhawk_1.CredsProvider[this.provider],
            name: this.name
        };
    };
    CreateIntegrationData.prototype.toSchedulingBriefBase = function () {
        return new services_jobot_scheduler_1.SchedulingBriefBaseStruct(this.toSchedulingBriefBaseSerialized());
    };
    CreateIntegrationData.prototype.loadSchedulingBriefBaseSerialized = function (slice) {
        this.provider = services_common_adhawk_1.CredsProvider[slice.provider];
        this.name = slice.name;
    };
    CreateIntegrationData.prototype.loadSchedulingBriefBase = function (slice) {
        this.loadSchedulingBriefBaseSerialized(slice.serialize());
    };
    CreateIntegrationData.prototype.serialize = function () {
        var _this = this;
        return {
            provider: services_common_adhawk_1.CredsProvider[this.provider],
            name: this.name,
            credentials: this.credentials.map(function (e) { return e.serialize(); }),
            tasks: this.tasks.map(function (e) { return e.serialize(); }),
            meta: typeof this.meta !== 'undefined' ? Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}) : undefined
        };
    };
    CreateIntegrationData.PackageName = 'net.playq.services.adhawk.scheduler';
    CreateIntegrationData.ClassName = 'CreateIntegrationData';
    CreateIntegrationData.FullClassName = 'net.playq.services.adhawk.scheduler.CreateIntegrationData';
    return CreateIntegrationData;
}());
exports.CreateIntegrationData = CreateIntegrationData;
services_jobot_scheduler_1.SchedulingBriefBaseStruct.register(CreateIntegrationData.FullClassName, CreateIntegrationData);
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(CreateIntegrationData.FullClassName, {
    full: CreateIntegrationData.FullClassName,
    short: CreateIntegrationData.ClassName,
    package: CreateIntegrationData.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new CreateIntegrationData(); },
    fields: [
        {
            name: 'provider',
            accessName: 'provider',
            type: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.services.common.adhawk.CredsProvider' }
        },
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'credentials',
            accessName: 'credentials',
            type: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.adhawk.creds.CredentialField' } }
        },
        {
            name: 'tasks',
            accessName: 'tasks',
            type: { intro: irt_1.IntrospectorTypes.List, value: { intro: irt_1.IntrospectorTypes.Data, full: 'net.playq.services.jobot.scheduler.RecurringTask' } }
        },
        {
            name: 'meta',
            accessName: 'meta',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Str } } }
        }
    ]
});
//# sourceMappingURL=CreateIntegrationData.js.map